import { createRouter, createWebHistory } from "vue-router";
import Index from "@/views/index/index.vue";
import newsList from "@/views/news/index.vue";
import newsDetails from "@/views/news/detailsIndex.vue";
import Center from "@/components/center.vue";
import notaryServices from "@/views/notaryServices/index.vue";
import legalService from "@/views/legalService/index.vue";
import exhibitionHall from "@/views/exhibitionHall/index.vue";
import Login from '@/views/login.vue';
import Register from '@/views/register.vue';
import RegisterAgree from '@/views/registerAgree.vue';
import xshzList from '@/views/xshz/xshzList.vue'
import xshzDetails from '@/views/xshz/xshzDetails.vue'
import aboutUs from '@/views/aboutUs/aboutUs.vue'
import logisticsServices from '@/views/logisticsServices/index.vue'
import foreignTrade from '@/views/foreignTrade/index.vue'
import trainServices from '@/views/trainServices/index.vue'
import trainServicesDetail from '@/views/trainServices/trainServicesDetail.vue'
import courseDetail from '@/views/trainServices/courseDetail.vue'
import sjzq from '@/views/sjzq/index.vue'
import roadTransport from '@/views/sjzq/roadTransport.vue'
import LoginYy from "@/views/loginYy.vue";





let allRouter = [

  {
    name: "",
    path: "/",
    component: Center, 
    children: [
      {
        name: "首页",
        path: "",
        component: Index,
        meta: { mobileReady: true }
      },{
        name: "资讯",
        path: "/newsList",
        component: newsList,
        meta: { mobileReady: true }
      },
      {
        name: "资讯详情",
        path: "/newsDetails",
        component: newsDetails,
        meta: { mobileReady: true }
      },
      {
        name: "关于我们",
        path: "/aboutUs",
        component: aboutUs,
      },
      {
        name: "物流服务",
        path: "/logisticsServices",
        component:logisticsServices,
      },
      {
        name: "公证服务",
        path: "/notaryServices",
        component:notaryServices,
      },
      {
        name: "法律服务",
        path: "/legalService",
        component: legalService,
      }, 
      {
        name: "外贸服务",
        path: "/foreignTrade",
        component: foreignTrade,
      },
      {
        name: "培训服务",
        path: "/trainServices",
        component: trainServices,
      },
      {
        name: "数据专区",
        path: "/sjzq",
        component: sjzq,
      },
      {
        name: "国际道路运输服务",
        path: "/roadTransport",
        component: roadTransport,
      },
       {
        name: "培训详情",
        path: "/trainServicesDetail",
        component: trainServicesDetail,
      },
      {
        name: "课程详情",
        path: "/courseDetail",
        component: courseDetail,
      },
      {
        name: "线上云展厅",
        path: "/exhibitionHall",
        component: exhibitionHall,
        meta: {
          FooterShow: true,   //是否显示页脚
        },
      },
      {
        name: "线上会展",
        path: "/xshzList",
        component: xshzList,
        meta: {
          FooterShow: true,   //是否显示页脚
        },
      },
      {
        name: "线上会展详情",
        path: "/xshzDetails",
        component: xshzDetails,
        meta: {
          FooterShow: true,   //是否显示页脚
        },
      },
      {
        name: "展会中心",
        path: "/exhibitionCenter",
        component: () => import("@/views/exhibition/exhibitionCenter.vue"),
      },
      {
        name: "展会动态详情",
        path: "/exhibitionCenterDetails",
        component: () => import("@/views/exhibition/exhibitionCenterDetails.vue"),

      },
      {
        name: "展会活动详情",
        path: "/exhibitionhdDetails",
        component: () => import("@/views/exhibition/exhibitionhdDetails.vue"),

      },
      {
        name: "展会详情",
        path: "/exhibitionDetails",
        component: () => import("@/views/exhibition/exhibitionDetails.vue"),

      },
      {
        name: "展会回顾",
        path: "/exhibitionReview",
        component: () => import("@/views/exhibition/exhibitionReview.vue"),

      },
      {
        name: "展会公告",
        path: "/exhibitionNotice",
        component: () => import("@/views/exhibition/exhibitionNotice.vue"),

      },
      {
        name: "数据分析",
        path: "/datAnalysis",
        component: () => import("@/views/datAnalysis/datAnalysis.vue"),
      },
      {
        name: "一站式搜索",
        path: "/oneStopSearch",
        component: () => import("@/views/oneStopSearch/index.vue"),
     
        children:[
          {
            name: "搜索资讯",
            path: "/oneStopSearchNews",
            component: () => import("@/views/oneStopSearch/news.vue"),
            meta: { mobileReady: true }
          },
          {
            name: "会展",
            path: "/oneStopSearchExhibitions",
            component: () => import("@/views/oneStopSearch/exhibitions.vue"),
            meta: { mobileReady: true }
          },
          {
            name: "服务",
            path: "/oneStopSearchService",
            component: () => import("@/views/oneStopSearch/service.vue"),
            meta: { mobileReady: true }
          },
        ]
      },
      {
        name: "人才服务",
        path: "/talentServices",
        component: () => import("@/views/talentServices/index.vue"),
      },
      {
        name: "用户指南",
        path: "/userGuide",
        component: () => import("@/views/userGuide/index.vue"),
        meta: { mobileReady: true }
      },
      {
        name: "服务案例",
        path: "/serviceCase",
        component: () => import("@/views/serviceCase/index.vue"),
        meta: { mobileReady: true }
      }
    ]
  }, {
    name: "登录",
    path: "/login",
    component: Login,
    meta: { mobileReady: true }
  },
  {
    path: '/iframeMes',
    name: 'iframe通信',
    component: () => import('@/views/iframeMes/index.vue')
  },
  {
    name: "运营登录",
    path: "/loginYy",
    component: LoginYy,
    meta: { mobileReady: true }
  }, {
    name: "注册",
    path: "/register",
    component: Register,
    meta: { mobileReady: true }
  }, {
    name: { label: "商通中心用户注册协议", moduleName: "商通中心用户注册协议" },
    path: "/registerAgree",
    component: RegisterAgree
  }, {
    name: { label: "隐私政策声明", moduleName: "隐私政策声明" },
    path: "/privacyPolicy", component: RegisterAgree
  },
  {
    name: { label: "法律声明", moduleName: "法律声明" },
    path: "/legaNotice", component: RegisterAgree
  },
  {
    name: { label: "用户中心", moduleName: "用户中心" },
    path: "/userCenter", component: () => import("@/views/userCenter/index.vue"),
  },

];
const router = createRouter({
  history: createWebHistory(process.env.NODE_ENV == 'test'? '/nfstzx/': '/'),
  routes: allRouter,
  scrollBehavior() {
    return { top: 0 };
  },
});
// createRouteGuard(router);
export default router;
